module.exports = __webpack_public_path__ + "img/12.a68cf205.png";